module.exports = __webpack_public_path__ + "static/media/newPie.c5bfe7da.svg";